import React from "react";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Checkbox,
} from "@mui/material";

/**
 * Controlled checklist.
 * props:
 *  - items: string[]  (display values; must be unique per checkpoint)
 *  - selected: string[]  (controlled selected values)
 *  - onSelectionChange(newSelected: string[]) => void
 */
const CheckList = ({ items = [], selected = [], onSelectionChange }) => {
  const handleToggle = (item) => {
    const idx = selected.indexOf(item);
    let next;
    if (idx === -1) {
      next = [...selected, item];
    } else {
      next = [...selected.slice(0, idx), ...selected.slice(idx + 1)];
    }
    onSelectionChange?.(next);
  };

  return (
    <List dense disablePadding>
      {items.map((item) => {
        const checked = selected.includes(item);
        return (
          <ListItem key={item} disablePadding>
            <ListItemButton onClick={() => handleToggle(item)}>
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  tabIndex={-1}
                  disableRipple
                  checked={checked}
                />
              </ListItemIcon>
              <ListItemText primary={item} />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
};

export default CheckList;
